import { render, staticRenderFns } from "./draggable-group-list.vue?vue&type=template&id=e7202e2e&scoped=true&"
import script from "./draggable-group-list.vue?vue&type=script&lang=js&"
export * from "./draggable-group-list.vue?vue&type=script&lang=js&"
import style0 from "./draggable-group-list.vue?vue&type=style&index=0&id=e7202e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7202e2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VIcon,VTextField})
